module.exports = __webpack_public_path__ + "static/media/LV.e5a70daf.svg";


//////////////////
// WEBPACK FOOTER
// ./src/svgs/flags/LV.svg
// module id = 305
// module chunks = 0